const isIncludesInBothArrays = (A: (string | number)[], B: (string | number)[]) =>
  A.map((item) => B.includes(item)).includes(true);

export default isIncludesInBothArrays;
